import { Injectable, makeEnvironmentProviders } from '@angular/core';
import { ɵSharedStylesHost } from '@angular/platform-browser';

// wrap material generated styles in a layer to avoid style conflicts with other libraries (like bootstrap)
// and to avoid style conflicts between different versions of material (like v14 and v15) when using microfrontends
// https://github.com/angular/components/issues/26451#issuecomment-4496755100

@Injectable()
export class LayeredSharedStylesHost extends ɵSharedStylesHost {
  private static readonly prefixes = [
    'mat-',
    '.mat-',
    '.mdc-',
    '.cdk-',
    'div.mat-',        // autocomplete panel
    '@keyframes _mat-', // snackbar animations
  ];

  protected override addUsage(...args: Parameters<ɵSharedStylesHost['addUsage']>) {
    args[0] = this.preprocessValue(args[0]);
    return super.addUsage(...args);
  }

  protected override removeUsage(...args: Parameters<ɵSharedStylesHost['removeUsage']>) {
    args[0] = this.preprocessValue(args[0]);
    return super.removeUsage(...args);
  }

  private preprocessValue(value: string) {
    if(value.startsWith('@layer')) {
      // already wrapped in a layer, do not wrap again
      return value;
    }

    // if(value.includes('@layer')) {
    //   debugger;
    // }

    for (const p of LayeredSharedStylesHost.prefixes) {
      if (value.startsWith(p))
        return `@layer modules { ${value} }`;
    }

    // wrap other css to application layer
    // return `@layer application { ${value} }`;

    return value;
  }
}

export function provideLayeredStylesV21() {
  return makeEnvironmentProviders([
    {
      provide: ɵSharedStylesHost,
      useClass: LayeredSharedStylesHost,
    },
  ]);
}

// import { ɵSHARED_STYLES_HOST } from '@angular/core';

// export function provideLayeredStylesv22() {
//   return makeEnvironmentProviders([
//     {
//       provide: ɵSHARED_STYLES_HOST,   // v22+: the token, not the class
//       useClass: LayeredSharedStylesHost,
//     },
//   ]);
// }
